import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7562f7ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "puzzle-step-title" }
const _hoisted_2 = { class: "text-md title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "step-text" }

import { puzzle, puzzleCorrectAnswers } from '@/data/puzzle'
import { useStorePuzzle } from '@/stores/puzzle'
import { PuzzleUserAnswer } from '@/types/Puzzle'
import PuzzleVideoCard from './PuzzleVideoCard.vue'
import correctCircleGreen from '@/assets/svg/correct-circle-green.svg'
import wrongCircle from '@/assets/svg/wrong-circle.svg'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentUserAnswers: null,
    id: null
  },
  emits: ['ondrop', 'onDragOver'],
  setup(__props: any, { emit }) {

const props = __props as {
  currentUserAnswers: PuzzleUserAnswer[]
  id: number
}



const puzzleStore = useStorePuzzle()



function getJustificationIcon(): string {
  if (isAnswerCorrect()) {
    return correctCircleGreen
  } else {
    return wrongCircle
  }
}

function allowDrop(ev: Event) {
  emit('onDragOver', ev)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function drop(ev: any) {
  emit('ondrop', ev)
}

function getPuzzleVideoSaved() {
  const userAnswer = props.currentUserAnswers.find(
    (userAnswer) => userAnswer.stepId === props.id
  )

  const puzzleVideo = puzzle.find(
    (puzzleVideo) => puzzleVideo.id === userAnswer?.videoId
  )

  if (!puzzleVideo) {
    return null
  }

  return puzzleVideo
}

function getJustificationBorder() {
  if (!puzzleStore.showJustification) {
    return
  }

  return isAnswerCorrect()
    ? 'puzzle-step-placeholder-correct'
    : 'puzzle-step-placeholder-wrong'
}

function isAnswerCorrect() {
  const userAnswer = props.currentUserAnswers.find(
    (userAnswer) => userAnswer.stepId === props.id
  )

  const isCorrect = puzzleCorrectAnswers.some(
    (puzzleCorrectAnswer) =>
      puzzleCorrectAnswer.stepId === userAnswer?.stepId &&
      puzzleCorrectAnswer.videoId === userAnswer?.videoId
  )

  return isCorrect
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('puzzle.step', [props.id])), 1),
      (_unref(puzzleStore).showJustification)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: getJustificationIcon(),
            alt: "Justification Icon"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["puzzle-step-placeholder", getJustificationBorder()]),
      id: `puzzle-step-placeholder-${props.id}`,
      ondrop: drop,
      ondragover: allowDrop
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(props.id), 1),
      (_unref(puzzleStore).showJustification)
        ? (_openBlock(), _createBlock(PuzzleVideoCard, {
            key: 0,
            "puzzle-video": getPuzzleVideoSaved(),
            draggable: !_unref(puzzleStore).showJustification
          }, null, 8, ["puzzle-video", "draggable"]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_4)
  ], 64))
}
}

})